import React from "react";

const ActiveSlideContext = React.createContext();

// Returns the value passed to the Provider component below
export const useActiveSlide = () => {
  return React.useContext(ActiveSlideContext);
};

// Sets up the Provider element with the scoped state
export const ActiveSlideProvider = ({ children }) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [isPaused, setIsPaused] = React.useState(false);

  return (
    <ActiveSlideContext.Provider
      value={{ activeIndex, setActiveIndex, isPaused, setIsPaused }}
    >
      {children}
    </ActiveSlideContext.Provider>
  );
};
